module.exports = __webpack_public_path__ + "img/4.38ea56e4.png";